import { ModelBase } from 'store/model-base';
import { PaymentStoreErrorCode } from 'my-account/constants';

export class OneTimePaymentResult extends ModelBase {
    public static storeName: string = 'oneTimePaymentResult';

    public state: string;
    public amount: number;
    public dueAmount: number;
    public saveCard: boolean;
    public errorCode: PaymentStoreErrorCode;
    public errorDescription: string;
}
